import { render } from "./ToastBase.vue?vue&type=template&id=2d1f79b8&scoped=true"
import script from "./ToastBase.vue?vue&type=script&lang=js"
export * from "./ToastBase.vue?vue&type=script&lang=js"

import "./ToastBase.vue?vue&type=style&index=0&id=2d1f79b8&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-2d1f79b8"

export default script